export enum BillingFrequencyEnum {
  Annually = 'ANNUALLY',
  Quarterly = 'QUARTERLY',
  Monthly  = 'MONTHLY',
  OneTime  = 'ONETIME',
}
